"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDidUpdateDeepCompareEffect = void 0;
var react_1 = require("react");
var use_deep_compare_effect_1 = __importDefault(require("use-deep-compare-effect"));
exports.useDidUpdateDeepCompareEffect = function useDidUpdateDeepCompareEffect(effect, deps) {
    var didMountRef = react_1.useRef(false);
    use_deep_compare_effect_1.default(function () {
        if (didMountRef.current)
            effect();
        else
            didMountRef.current = true;
    }, deps);
};
//# sourceMappingURL=useDidUpdateDeepCompareEffect.js.map